<div class="page-contents">
  <div class="subBlockContainer">
    <div class="breadcrumbWrapper">
      <app-breadcrumb></app-breadcrumb>
    </div>

    <div class="subBlockContent">
      <div class="page-title-wrapper">
          <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i>
      </div>
        
        <div class="inner-subBlock-wrapper">
              <div class="error-msg-panel">
                <div>
                  <img class="errorImage" src="../images/new_ui/404error.png">
                  <img class="oopsImage" src="../images/new_ui/oops.png">
                  <label class="error-msg-label">
                      The page your're trying to reach doesn't exist.
                  </label>
                  <button class="button button-red btn-long" [routerLink]="['/home']">Go to dashboard</button>
                  <a href="javascript:void(0)" class="previous-link" (click)="navigateToPrevious()">Previous Page</a>
                </div>
              </div>
        </div>

    </div>
  </div>
</div>